import React from "react";

const NoActivity = ()=> {
  return (
    <div>没有xxx活动</div>
  )
}

export default NoActivity;